import React, { useState } from "react";
import { Collapse } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import "./FAQs.scss";

const FAQs = () => {
  const [faq1, setFaq1] = useState(false);
  const [faq2, setFaq2] = useState(false);
  const [faq3, setFaq3] = useState(false);
  const [faq4, setFaq4] = useState(false);
  const [faq5, setFaq5] = useState(false);
  const [faq6, setFaq6] = useState(false);
  const [faq7, setFaq7] = useState(false);
  const [faq8, setFaq8] = useState(false);
  const [faq9, setFaq9] = useState(false);
  const [faq10, setFaq10] = useState(false);
  const [faq11, setFaq11] = useState(false);
  const [faq12, setFaq12] = useState(false);

  return (
    <div className="row justify-content-center panel-faqs">
      <div className="col-12 col-md-8 faqs-container">
        <h3 className="text-uppercase text-center text-blue mb-5 mt-5">
          Frequently Asked Questions
        </h3>
        <div className="faq-item">
          <button
            onClick={() => setFaq1(!faq1)}
            aria-controls="faq1"
            aria-expanded={faq1}
          >
            What are Paving Stones?
            <span className={faq1 ? "active" : ""}>
              <FontAwesomeIcon icon={faChevronDown} />
            </span>
          </button>
          <Collapse in={faq1}>
            <div className="faq-description" id="faq1">
              Paving stones are compressed concrete units that are used for
              driveways, patios, walkways and more. What makes them unique is
              that instead of being mortared into place over a concrete slab,
              they are laid down on a bed of compacted road base and a leveling
              layer of sand. Additional joints sand is installed between the
              joints. This creates an interlocking system of stones that is not
              only very strong and secure, but also allows flexibility if
              needed. This means that paving stones won’t crack due to weather
              conditions or movement. They are even earthquake resistant, which
              makes them a great choice if you live in Southern California.
            </div>
          </Collapse>
        </div>
        <div className="faq-item">
          <button
            onClick={() => setFaq2(!faq2)}
            aria-controls="faq2"
            aria-expanded={faq2}
          >
            Why Choose Paving Stones Instead of Asphalt or Poured Concrete?
            <span className={faq2 ? "active" : ""}>
              <FontAwesomeIcon icon={faChevronDown} />
            </span>
          </button>
          <Collapse in={faq2}>
            <div className="faq-description" id="faq2">
              Paving stones are four times stronger than traditional poured
              concrete. Because of their strength and durability, paving stones
              are used in many industrial settings such as airports, shipping
              docks and factories. And of course, they are extremely popular for
              residential upgrades including new driveways, pool decks, patios
              and entryways. One of the great things about paving stones is how
              easy they are to maintain. If grease, oil or paint gets on your
              pavers, you can easily replace them. It’s as simple as popping out
              the old one and inserting a new one. This is not possible with a
              concrete or asphalt surface, and large stains or cracks most
              likely means the whole area will need to be replaced.
            </div>
          </Collapse>
        </div>
        <div className="faq-item">
          <button
            onClick={() => setFaq3(!faq3)}
            aria-controls="faq3"
            aria-expanded={faq3}
          >
            Do Paving Stones Come in Different Colors?
            <span className={faq3 ? "active" : ""}>
              <FontAwesomeIcon icon={faChevronDown} />
            </span>
          </button>
          <Collapse in={faq3}>
            <div className="faq-description" id="faq3">
              Paving stones come in an array of sizes, shapes, colors and
              styles. <Link to="/styles/variations">Click here</Link> to see
              some of the most popular styles.
            </div>
          </Collapse>
        </div>
        <div className="faq-item">
          <button
            onClick={() => setFaq4(!faq4)}
            aria-controls="faq4"
            aria-expanded={faq4}
          >
            Can You Have Multiple Paving Stone Styles in One Design?
            <span className={faq4 ? "active" : ""}>
              <FontAwesomeIcon icon={faChevronDown} />
            </span>
          </button>
          <Collapse in={faq4}>
            <div className="faq-description" id="faq4">
              Yes! The possibilities are endless with paving stones. You can
              combine stones and colors to create patterns and designs.
            </div>
          </Collapse>
        </div>
        <div className="faq-item">
          <button
            onClick={() => setFaq5(!faq5)}
            aria-controls="faq5"
            aria-expanded={faq5}
          >
            How Long Do Paving Stones Last?
            <span className={faq5 ? "active" : ""}>
              <FontAwesomeIcon icon={faChevronDown} />
            </span>
          </button>
          <Collapse in={faq5}>
            <div className="faq-description" id="faq5">
              If Paving Stones are sealed when installed, they can last decades.
              If you get a damaged stone or stain on your paving stone surface,
              you can replace the affected stone in lieu of replacing the entire
              area.
            </div>
          </Collapse>
        </div>
        <div className="faq-item">
          <button
            onClick={() => setFaq6(!faq6)}
            aria-controls="faq6"
            aria-expanded={faq6}
          >
            What is Paver Sealer?
            <span className={faq6 ? "active" : ""}>
              <FontAwesomeIcon icon={faChevronDown} />
            </span>
          </button>
          <Collapse in={faq6}>
            <div className="faq-description" id="faq6">
              Paver sealer is a coating that’s applied over a paving stone
              project to protect it. Sealer prevents staining and helps the
              stones retain their natural color.
            </div>
          </Collapse>
        </div>
        <div className="faq-item">
          <button
            onClick={() => setFaq7(!faq7)}
            aria-controls="faq7"
            aria-expanded={faq7}
          >
            Do You Offer a Warranty on a Paving Stone Installations?
            <span className={faq7 ? "active" : ""}>
              <FontAwesomeIcon icon={faChevronDown} />
            </span>
          </button>
          <Collapse in={faq7}>
            <div className="faq-description" id="faq7">
              Our warranty varies based on the type of work but is consistent
              with industry standards. When you meet one of our designers, they
              can walk you through it or call us at (818) 658-9370 for more
              information.
            </div>
          </Collapse>
        </div>
        <div className="faq-item">
          <button
            onClick={() => setFaq8(!faq8)}
            aria-controls="faq8"
            aria-expanded={faq8}
          >
            Is There a Minimum for Your Projects?
            <span className={faq8 ? "active" : ""}>
              <FontAwesomeIcon icon={faChevronDown} />
            </span>
          </button>
          <Collapse in={faq8}>
            <div className="faq-description" id="faq8">
              Our projects start at $7,500.
            </div>
          </Collapse>
        </div>
        <div className="faq-item">
          <button
            onClick={() => setFaq9(!faq9)}
            aria-controls="faq9"
            aria-expanded={faq9}
          >
            Do I Need to Pull My Own Permits?
            <span className={faq9 ? "active" : ""}>
              <FontAwesomeIcon icon={faChevronDown} />
            </span>
          </button>
          <Collapse in={faq9}>
            <div className="faq-description" id="faq9">
              If permits are needed for your job, we will pull them! You can
              always obtain your own permits as well.
            </div>
          </Collapse>
        </div>
        <div className="faq-item">
          <button
            onClick={() => setFaq10(!faq10)}
            aria-controls="faq10"
            aria-expanded={faq10}
          >
            Do You Need a Gas Line for a Fire Pit?
            <span className={faq10 ? "active" : ""}>
              <FontAwesomeIcon icon={faChevronDown} />
            </span>
          </button>
          <Collapse in={faq10}>
            <div className="faq-description" id="faq10">
              Fire pits can be prefabricated or built custom. If you don’t want
              to run a gas line, you can purchase a prefabricated option that
              runs on propane tanks.
            </div>
          </Collapse>
        </div>
        <div className="faq-item">
          <button
            onClick={() => setFaq11(!faq11)}
            aria-controls="faq11"
            aria-expanded={faq11}
          >
            How Long Will it Take to Install My Project?
            <span className={faq11 ? "active" : ""}>
              <FontAwesomeIcon icon={faChevronDown} />
            </span>
          </button>
          <Collapse in={faq11}>
            <div className="faq-description" id="faq11">
              This can vary as well, depending on the size of the job, permits
              needed and many other factors. Very small jobs can be wrapped up
              in a week. Large projects can sometimes take 3-6 months. Your
              designer and job supervisor can give you a more exact timeline
              once your design is complete.
            </div>
          </Collapse>
        </div>
        <div className="faq-item">
          <button
            onClick={() => setFaq12(!faq12)}
            aria-controls="faq12"
            aria-expanded={faq12}
          >
            What Are Your Service Areas?
            <span className={faq12 ? "active" : ""}>
              <FontAwesomeIcon icon={faChevronDown} />
            </span>
          </button>
          <Collapse in={faq12}>
            <div className="faq-description" id="faq12">
              Pacific Pavingstone services Los Angeles and the greater Los
              Angeles area. <Link to="/about-us/service-areas">Click here</Link>
               to see a list of our service areas.
            </div>
          </Collapse>
        </div>
      </div>
    </div>
  );
};

export default FAQs;
